import axios from 'axios'

export default {
  list (context, opts) {
    const options = opts ? { params: opts } : {}
    return new Promise((resolve, reject) => {
      axios
        .get('/api/scanresult', options)
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  detail (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/scanresult/${opts.id}`)
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/scanresult/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    axios
      .get(`/api/scanresult/${opts}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
        }
      }).catch(() => {
      })
  },
  async updated (context, opts) {
    if (context.state.current.id === opts || context.state.list.find((i) => i.id === opts) !== undefined) {
      try {
        const { data } = await axios.get(`/api/scanresult/${opts}?excludeResult=true`)
        if (data.id) {
          context.commit('LIST_UPDATE', data)
          if (data.id === context.state.current.id) {
            context.commit('CURRENT', data)
          }
        }
      } catch (e) {}
    }
  },
  destroyed (context, opts) {
    context.commit('LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  async manualScans (context, opts) {
    const { data } = await axios.get('/api/scanresult/manual-scans')
    if (data) {
      context.commit('MANUAL_SCANS', data)
    }
  }
}
